import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { max, min } from '../../../theme/breakpoints';

export const ContentWrapper = styled(motion.div)`
  position: relative;
  background-color: ${({ theme }) => (theme.name === 'uplay' ? theme.colors.backgroundColor : theme.colors.Alabaster)};

  .about-bg {
    background-position: 0% 50%;
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding: 3.75rem 0;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background: ${({ theme }) =>
        theme.name === 'uplay'
          ? 'linear-gradient(270.04deg, #1C2125 36.08%, rgba(28, 33, 37, 0) 48.22%)'
          : 'linear-gradient(270.04deg, #fafafa 36.08%, rgba(250, 250, 250, 0) 48.22%)'};
      z-index: 1;
    }
    @media screen and ${min('tablet')} {
      padding: 3.75rem 0;
    }
    @media screen and ${min('desktop')} {
      padding: 5rem 0;
    }
    @media screen and ${max('tablet')} {
      background-image: none !important;

      &::after {
        display: none;
      }
    }
  }
`;

export const Content = styled.div`
  margin: auto;
  max-width: 90rem;
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
  position: relative;
  z-index: 2;

  @media screen and ${min('tablet')} {
    padding: 0 2.75rem;
  }
  @media screen and ${min('desktop')} {
    padding: 0 1rem;
  }

  .about-trailer-cta {
    color: ${({ theme }) => theme.colors.text};
    > span {
      display: flex;
      justify-content: center;
      align-items: center;

      > svg {
        margin-left: 0.8rem;

        > g path {
          fill: ${({ theme }) => theme.colors.text};
        }
      }
    }
  }

  @media screen and ${max('largeTablet')} {
    flex-direction: column;
  }
`;

export const InfoSection = styled.div`
  width: 35%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  > h2 {
    margin-bottom: 0.5rem;

    @media screen and ${max('desktop')} {
      margin-bottom: 1rem;
    }
  }

  > p {
    margin-bottom: 0;
    font-family: ${({ theme }) => theme.fonts.primary.regular};
    color: ${({ theme }) => theme.colors.text};
    font-size: 1.125rem;
    line-height: 1.6rem;
    letter-spacing: 0.04rem;

    @media screen and ${max('desktop')} {
      font-size: 0.75rem;
    }

    @media screen and ${max('mobile')} {
      font-size: 1rem;
    }
  }

  @media screen and ${max('largeTablet')} {
    width: 100%;
    align-items: flex-start;
  }

  @media screen and ${max('mobile')} {
    padding: 0;
  }
`;

export const OverTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary.light};
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  font-size: 1.125rem;
  text-transform: uppercase;

  > svg {
    margin-right: 0.5rem;
    height: 20px;

    @media screen and ${max('desktop')} {
      height: 1rem;
    }
  }

  @media screen and ${max('desktop')} {
    font-size: 0.75rem;
  }
`;

const TrailerContainerRules = css`
  display: inline-flex;
  position: relative;
  margin-right: auto;
  width: 825px;
  margin-bottom: 2rem;

  @media screen and ${min('desktop')} {
    margin-right: 2.75rem;
  }
  @media screen and ${max('desktop')} {
    width: 60%;
  }
  @media screen and ${max('largeTablet')} {
    width: 100%;
    height: 0;
    padding: 25%;
  }
  @media screen and ${max('largeTablet')} {
    width: 100%;
    height: 0;
    padding: 25%;
  }
  @media screen and ${min('largeTablet')} {
    margin-bottom: 0;
  }
`;

export const TrailerButton = styled(motion.button)`
  cursor: pointer;
  appearance: none;
  border: 0;
  background: transparent;
  overflow: hidden;
  ${TrailerContainerRules};

  .player-image {
    width: 100%;
    height: 100%;
    object-fit: cover;

    @media screen and ${max('tablet')} {
      order: 1;
    }
    @media screen and ${max('largeTablet')} {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  svg {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: 0.2s all ease-in-out;

    @media screen and ${max('tablet')} {
      width: 60px;
      height: 60px;
    }
  }
  @media screen and ${min('largeTablet')} {
    &:hover {
      svg {
        transform: translate(-50%, -50%) scale(1.05);
      }
    }
  }
`;

export const TrailerContainer = styled.div`
  ${TrailerContainerRules};
  iframe {
    position: absolute;
    left: 0;
    top: 0;
    border: 0;
    width: 100%;
    height: 100%;
    z-index: 11;
  }
`;
